import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_UPDATE_CUSTOMER } from 'constants/urls';

const updateCustomer = async (customerData: Record<string, unknown>) => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: URL_CANTRACK_UPDATE_CUSTOMER,
      data: { payload: customerData },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
    return data;
  } catch (error) {
    console.error('[updateCustomer] Failed:', error);
    throw error;
  }
};

export default updateCustomer;
